import { MaskLine } from "../components/Reveal";
import GroutVisualizer from "../components/GroutVisualizer";
import SEO, { SEO_CONFIG } from "../components/SEO";
import { useLanguage } from "../i18n/LanguageContext";

export default function GroutVisualizerPage() {
  const { t, lang } = useLanguage();

  const visualizerSchema = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": SEO_CONFIG.groutVisualizer.title,
    "description": SEO_CONFIG.groutVisualizer.description,
    "url": SEO_CONFIG.groutVisualizer.canonical,
    "applicationCategory": "DesignApplication",
    "operatingSystem": "All"
  };

  return (
    <div className="pt-20" data-testid="grout-visualizer-page">
      <SEO {...SEO_CONFIG.groutVisualizer} schema={visualizerSchema} />
      <section className="mx-auto max-w-[1600px] px-6 pb-12 pt-20 md:px-10 md:pb-16 md:pt-28">
        <span className="label text-primary">{t("visualizerPage.eyebrow")}</span>
        <h1
          className={`mt-6 font-display text-4xl font-bold sm:text-6xl md:text-8xl ${
            lang === "hi"
              ? "normal-case leading-[1.15] tracking-normal"
              : "uppercase leading-[0.85] tracking-tighter"
          }`}
        >
          <MaskLine delay={0.05}>{t("visualizerPage.h1a")}</MaskLine>
          <MaskLine delay={0.18}><span className="text-primary">{t("visualizerPage.h1b")}</span></MaskLine>
        </h1>
        <p className="mt-6 max-w-xl text-base text-muted-foreground md:text-lg">
          {t("visualizerPage.intro")}
        </p>
      </section>

      <section className="mx-auto max-w-[1600px] px-6 pb-32 md:px-10">
        <GroutVisualizer />
      </section>
    </div>
  );
}
